// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"block-wrapper_blockWrapper___bsFv"};